import initialState from './initialState';
import { reducer as addProjectConstantReducer } from './addProjectConstant';
import { reducer as changeDefaultPageReducer } from './changeDefaultPage';
import { reducer as deleteProjectConstantReducer } from './deleteProjectConstant';
import { reducer as updateProjectConstantReducer } from './updateProjectConstant';
import { reducer as addProjectCustomCssReducer } from './addProjectCustomCss';
import { reducer as loadDefaultPageReducer } from './loadDefaultPage';
import { reducer as addProjectRobotsTxtReducer } from './addProjectRobotsTxt';
import { reducer as loadAppSettingPagesReducer } from './loadAppSettingPages';
import { reducer as loadPageSnapshotsReducer } from './loadPageSnapshots';
import { reducer as loadSnippetSnapshotsReducer } from './loadSnippetSnapshots';
import { reducer as changeProjectLoadingIconReducer } from './changeProjectLoadingIcon';
import { reducer as saveLayoutReducer } from './saveLayout';
import { reducer as loadLayoutsReducer } from './loadLayouts';
import { reducer as deleteLayoutReducer } from './deleteLayout';
import { reducer as updateLayoutReducer } from './updateLayout';
import { reducer as addProjectCustomCssClassReducer } from './addProjectCustomCssClass';
import { reducer as deleteProjectCustomCssClassReducer } from './deleteProjectCustomCssClass';
import { reducer as addEnvironmentInProjectReducer } from './addEnvironmentInProject';
import { reducer as removeEnvironmentFromProjectReducer } from './removeEnvironmentFromProject';
import { reducer as addProjectCustomCssUrlReducer } from './addProjectCustomCssUrl';
import { reducer as deleteProjectCustomCssUrlReducer } from './deleteProjectCustomCssUrl';
import { reducer as addProjectCustomJsReducer } from './addProjectCustomJs';
import { reducer as addProjectCustomJsCdnReducer } from './addProjectCustomJsCdn';
import { reducer as deleteProjectCustomJsCdnReducer } from './deleteProjectCustomJsCdn';
import { reducer as updateProjectCustomJsCdnReducer } from './updateProjectCustomJsCdn';
import { reducer as updateProjectCustomCssCdnReducer } from './updateProjectCustomCssCdn';
import { reducer as toggleProjectDefaultJsReducer } from './toggleProjectDefaultJs';
import { reducer as saveProjectPwaConfigReducer } from './saveProjectPwaConfig';
import { reducer as deleteProjectPwaConfigReducer } from './deleteProjectPwaConfig';
import { reducer as togglePwaReducer } from './togglePwa';
import { reducer as updateDevKeyReducer } from './updateDevKey';
import { reducer as updateEnvironmentProjectReducer } from './updateEnvironmentProject';
import { reducer as addEnvConstantReducer } from './addEnvConstant';
import { reducer as updateEnvConstantReducer } from './updateEnvConstant';
import { reducer as removeEnvConstantReducer } from './removeEnvConstant';
import { reducer as loadCustomThemeFilesReducer } from './loadCustomThemeFiles';
import { reducer as deleteCustomThemeFileReducer } from './deleteCustomThemeFile';
import { reducer as loadCustomCssCdnsReducer } from './loadCustomCssCdns';
import { reducer as loadCustomJsCdnsReducer } from './loadCustomJsCdns';
import { reducer as toggleEncryptionReducer } from './toggleEncryption';
import { reducer as updateEncryptionSettingReducer } from './updateEncryptionSetting';
import { reducer as addNotificationSettingReducer } from './addNotificationSetting';
import { reducer as deletePageSnapshotReducer } from './deletePageSnapshot';
import { reducer as deleteSnippetSnapshotReducer } from './deleteSnippetSnapshot';
import { reducer as loadLocalizationDataReducer } from './loadLocalizationData';
import { reducer as addLocalizationKeyValueReducer } from './addLocalizationKeyValue';
import { reducer as deleteLocalizationKeyValueReducer } from './deleteLocalizationKeyValue';
import { reducer as updateLocalizationKeyValueReducer } from './updateLocalizationKeyValue';
import { reducer as saveLocalizationConfigReducer } from './saveLocalizationConfig';
import { reducer as deleteLocalizationConfigReducer } from './deleteLocalizationConfig';
import { reducer as changeDefaultLanguageReducer } from './changeDefaultLanguage';
import { reducer as updateDateFormatReducer } from './updateDateFormat';
import { reducer as fetchCssdataReducer } from './fetchCssdata';
import { reducer as fetchJsEditorDataReducer } from './fetchJsEditorData';
import { reducer as toggleCssEditorModalReducer } from './toggleCssEditorModal';
import { reducer as saveCssFileReducer } from './saveCssFile';
import { reducer as toggleJsEditorModalReducer } from './toggleJsEditorModal';
import { reducer as saveJsFileReducer } from './saveJsFile';
import { reducer as toggleProjectCustomJsReducer } from './toggleProjectCustomJs';
import { reducer as toggleProjectDefaultCssReducer } from './toggleProjectDefaultCss';
import { reducer as toggleProjectJsCdnsFromBuilderReducer } from './toggleProjectJsCdnsFromBuilder';
import { reducer as toggleProjectCssCdnsFromBuilderReducer } from './toggleProjectCssCdnsFromBuilder';
import { reducer as toggleProfilerReducer } from './toggleProfiler';
import { reducer as getAllTrackingActivityReducer } from './getAllTrackingActivity';
import { reducer as createProjectVersionReducer } from './createProjectVersion';
import { reducer as loadProjectDetailAppSettingReducer } from './loadProjectDetailAppSetting';
import { reducer as deleteProjectVersionReducer } from './deleteProjectVersion';
import { reducer as getPublishtrackReducer } from './getPublishtrack';
import { reducer as loadCustomHtmlFilesReducer } from './loadCustomHtmlFiles';
import { reducer as loadAllResourcesReducer } from './loadAllResources';
import { reducer as deleteResourcesReducer } from './deleteResources';
import { reducer as loadPageDetailsReducer } from './loadPageDetails';
import { reducer as updatePageScriptReducer } from './updatePageScript';
import { reducer as loadProjectCollectionsReducer } from './loadProjectCollections';
import { reducer as enableDeveloperApisReducer } from './enableDeveloperApis';
import { reducer as loadAllDevApisReducer } from './loadAllDevApis';
import { reducer as loadEmailTemplatesReducer } from './loadEmailTemplates';
import { reducer as getPermissionFlagsReducer } from './getPermissionFlags';
import { reducer as customDomainsUpdateReducer } from './customDomainsUpdate';
import { reducer as fetchProjectReducer } from './fetchProject';
import { reducer as loadCollectionSnapshotsReducer } from './loadCollectionSnapshots';
import { reducer as deleteCollectionSnapshotReducer } from './deleteCollectionSnapshot';
import { reducer as updateIpAddressesReducer } from './updateIpAddresses';
import { reducer as loadUserRolesReducer } from './loadUserRoles';
import { reducer as loadPermissionsReducer } from './loadPermissions';
import { reducer as addProjectSitemapXmlReducer } from './addProjectSitemapXml';
import { reducer as overwriteDefaultUiReducer } from './overwriteDefaultUi';
import { reducer as updateEncAwsSettingReducer } from './updateEncAwsSetting';
import { reducer as resetEncryptionSettingReducer } from './resetEncryptionSetting';
import { reducer as cypherTextReducer } from './cypherText';
import { reducer as getProfilerDataReducer } from './getProfilerData';
import { reducer as deleteProfilerReducer } from './deleteProfiler';
import { reducer as updateAiModelConfigReducer } from './updateAiModelConfig';
import { reducer as loaderScreenSettingsReducer } from './loaderScreenSettings';
import { reducer as refreshProjectReducer } from './refreshProject';
import { reducer as importProjectReducer } from './importProject';
import { reducer as fetchFigmatokenReducer } from './fetchFigmatoken';
import { reducer as fetchFigmaDataReducer } from './fetchFigmaData';
import { reducer as fetchFigmaImageReducer } from './fetchFigmaImage';
import { reducer as deleteFigmaToHtmlDataReducer } from './deleteFigmaToHtmlData';
import { reducer as deleteFigmaTokenDetailsReducer } from './deleteFigmaTokenDetails';
import { reducer as fetchFigmaToHtmlDataReducer } from './fetchFigmaToHtmlData';
import { reducer as generateFigmaToHtmlReducer } from './generateFigmaToHtml';

const reducers = [
  addProjectConstantReducer,
  changeDefaultPageReducer,
  deleteProjectConstantReducer,
  updateProjectConstantReducer,
  addProjectCustomCssReducer,
  loadDefaultPageReducer,
  addProjectRobotsTxtReducer,
  loadAppSettingPagesReducer,
  loadPageSnapshotsReducer,
  loadSnippetSnapshotsReducer,
  saveLayoutReducer,
  loadLayoutsReducer,
  deleteLayoutReducer,
  updateLayoutReducer,
  changeProjectLoadingIconReducer,
  addProjectCustomCssClassReducer,
  deleteProjectCustomCssClassReducer,
  addEnvironmentInProjectReducer,
  removeEnvironmentFromProjectReducer,
  addProjectCustomCssUrlReducer,
  deleteProjectCustomCssUrlReducer,
  addProjectCustomJsReducer,
  addProjectCustomJsCdnReducer,
  deleteProjectCustomJsCdnReducer,
  updateProjectCustomJsCdnReducer,
  updateProjectCustomCssCdnReducer,
  toggleProjectDefaultJsReducer,
  saveProjectPwaConfigReducer,
  deleteProjectPwaConfigReducer,
  togglePwaReducer,
  updateDevKeyReducer,
  updateEnvironmentProjectReducer,
  addEnvConstantReducer,
  updateEnvConstantReducer,
  removeEnvConstantReducer,
  loadCustomThemeFilesReducer,
  deleteCustomThemeFileReducer,
  loadCustomCssCdnsReducer,
  loadCustomJsCdnsReducer,
  toggleEncryptionReducer,
  updateEncryptionSettingReducer,
  addNotificationSettingReducer,
  deletePageSnapshotReducer,
  deleteSnippetSnapshotReducer,
  loadLocalizationDataReducer,
  addLocalizationKeyValueReducer,
  deleteLocalizationKeyValueReducer,
  updateLocalizationKeyValueReducer,
  saveLocalizationConfigReducer,
  deleteLocalizationConfigReducer,
  changeDefaultLanguageReducer,
  updateDateFormatReducer,
  fetchCssdataReducer,
  fetchJsEditorDataReducer,
  toggleCssEditorModalReducer,
  saveCssFileReducer,
  toggleJsEditorModalReducer,
  saveJsFileReducer,
  toggleProjectCustomJsReducer,
  toggleProjectDefaultCssReducer,
  toggleProjectJsCdnsFromBuilderReducer,
  toggleProjectCssCdnsFromBuilderReducer,
  toggleProfilerReducer,
  getAllTrackingActivityReducer,
  getAllTrackingActivityReducer,
  createProjectVersionReducer,
  loadProjectDetailAppSettingReducer,
  deleteProjectVersionReducer,
  getPublishtrackReducer,
  loadCustomHtmlFilesReducer,
  loadAllResourcesReducer,
  deleteResourcesReducer,
  loadPageDetailsReducer,
  updatePageScriptReducer,
  loadProjectCollectionsReducer,
  enableDeveloperApisReducer,
  loadAllDevApisReducer,
  loadEmailTemplatesReducer,
  getPermissionFlagsReducer,
  customDomainsUpdateReducer,
  fetchProjectReducer,
  loadCollectionSnapshotsReducer,
  deleteCollectionSnapshotReducer,
  updateIpAddressesReducer,
  loadUserRolesReducer,
  loadPermissionsReducer,
  addProjectSitemapXmlReducer,
  overwriteDefaultUiReducer,
  updateEncAwsSettingReducer,
  resetEncryptionSettingReducer,
  cypherTextReducer,
  getProfilerDataReducer,
  deleteProfilerReducer,
  updateAiModelConfigReducer,
  loaderScreenSettingsReducer,
  refreshProjectReducer,
  importProjectReducer,
  fetchFigmatokenReducer,
  fetchFigmaDataReducer,
  fetchFigmaImageReducer,
  deleteFigmaToHtmlDataReducer,
  deleteFigmaTokenDetailsReducer,
  fetchFigmaToHtmlDataReducer,
  generateFigmaToHtmlReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
